import { Client } from '@gradio/client';

const HF_TOKEN = process.env.REACT_APP_HUGGING_FACE_TOKEN;

/** Predict a number from an ovulation test strip image using Hugging Face model */
export async function predictTestNumber(imageBlob) {
  console.log('[HF] === STARTING PREDICTION ===');
  console.log('[HF] Image size:', imageBlob.size, 'bytes');

  try {
    const spaceId = 'OnTheMark1994/Test-Prediction-Bin-Calc';
    const endpoint = '/predict_image';
    console.log('[HF] Connecting to Space:', spaceId);

    const client = await Client.connect(spaceId, HF_TOKEN ? { token: HF_TOKEN } : undefined);
    console.log('[HF] Connected, calling predict...');
    const result = await client.predict(endpoint, { image: imageBlob });
    console.log('[HF] Result received:', result);

    // Extract full response from result.data (array)
    const responseData = Array.isArray(result.data) ? result.data[0] : result.data;
    console.log('[HF] Extracted response data:', responseData);

    return responseData;
  } catch (error) {
    console.error('[HF] Prediction error:', error);
    return null; // Return null so caller knows AI failed — don't fake a value
  }
}
